import React from "react";
import figma from "../../AuthorDashboard/AddingProducts/Details/icons/Icon.png";
import sketch from "../../AuthorDashboard/AddingProducts/Details/icons/Icon (1).png";
import adobexd from "../../AuthorDashboard/AddingProducts/Details/icons/Icon (2).png";

export const Upper = ({data}) => {
  return (
    <div className="md:w-1/2 mx-auto">
      <img
        className="w-[110px] h-[92px] rounded-xl mx-auto"
        src={data.card.picture}
        alt=""
      />
      <div className="text-center py-4 md:py-5">
        <h1 className="text-[28px] md:text-[32px] ">{data.card.header}</h1>
        <p className="text-xl md:pt-3">
          Energize your creative workflow with Atro app design ui kit.
        </p>
      </div>
      <div className="flex items-center space-x-4 justify-center">
        <img
          className="shrink-0 w-10 rounded-full h-10 object-cover"
          src={data.card.user.picture}
          alt=""
        />
        <p>By {data.card.user.name}</p>
        <hr className="h-7 w-[2px] bg-[#D3D3D3] dark:bg-gray-500" />
        <p className="border-[1.2px] border-[#1C1C1C] dark:border-gray-500 py-[6px] px-[10px] rounded w-fit shrink-0">UI Kits</p>
        <hr className="h-7 w-[2px] bg-[#D3D3D3] dark:bg-gray-500" />
        <div className="flex items-center">
          <div className="border bg-white border-[#D3D3D3] dark:border-gray-500 dark:bg-[#1C1C1C] p-2 text-4xl rounded-full">
            <img className="" src={figma} alt="" />
          </div>
          <div className="-translate-x-2 border bg-white border-[#D3D3D3] dark:border-gray-500 dark:bg-[#1C1C1C] p-2 text-4xl rounded-full">
            <img src={sketch} alt="" />
          </div>
          <div className="-translate-x-4 border bg-white border-[#D3D3D3] dark:border-gray-500 dark:bg-[#1C1C1C] p-2 text-4xl rounded-full">
            <img src={adobexd} alt="" />
          </div>
         
        </div>
      </div>
      <div className="mt-4 flex  items-center justify-between  space-x-4 border dark:border-gray-500 px-4 py-2 rounded-lg overflow-x-scroll hidescroll">
        <div>
          <p>Mobible Screens</p>
          <p>188</p>
        </div>
        <hr className="h-7 w-[2px] dark:bg-gray-500 bg-[#D3D3D3]" />
        <div>
          <p>Industry</p>
          <p>Multipurpose</p>
        </div>
        <hr className="h-7 w-[2px] dark:bg-gray-500 bg-[#D3D3D3]" />
        <div>
          <p>Audience</p>
          <p>Design Agencies</p>
        </div>
        <hr className="h-7 w-[2px] dark:bg-gray-500 bg-[#D3D3D3]" />
        <div>
          <p>Theme</p>
          <p>Light & Dark</p>
        </div>
      </div>
    </div>
  );
};
